import React from 'react'
import {Button} from '../ButtonElements'
import {InfoContainer,InfoWrapper,InfoRow,Column1,Column2
    ,TextWrapper,TopLine,Heading,Subtitle,BtnWrap,BtnLink
,ImgWrap,Img} from './infoElements'



// const Mailto = ({ email, subject = '', body = '', children }) => {
//     let params = subject || body ? '?' : '';
//     if (subject) params += `subject=${encodeURIComponent(subject)}`;
//     if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;
  
//     return <a href={`mailto:${email}${params}`}>{children}</a>;
//   };


const InfoSection = ({lightBg,id,imgStart,topLine,lightText,headLine
,darkText,description,description1,buttonLable,img,alt,primary,dark,dark2,to,LinkLable}) => {
  return (
        <InfoContainer lightBg ={lightBg} id={id}>
            <InfoWrapper>
                <InfoRow imgStart={imgStart}>
                    <Column1>
                    <TextWrapper>
                        <TopLine>{topLine}</TopLine>
                        <Heading lightText = {lightText}>{headLine}</Heading>
                        <Subtitle darkText = {darkText}> 
                        {description}</Subtitle>
                        <Subtitle darkText = {darkText}>{description1} </Subtitle>
                        <BtnWrap>
                            <Button to={to}
                            smooth={true}
                            duration={500}
                            spy={true}
                            exact="true"
                            offset={-80}
                            primary={primary?1:0}
                            dark={dark?1:0}
                            dark2={dark2?1:0}
                            >
                                {buttonLable}
                                </Button>
                        </BtnWrap>
                    </TextWrapper>
                    </Column1>
                    <Column2>
                    <ImgWrap>
                    <Img src={img} alt={alt}/>
                    </ImgWrap>
                    </Column2> 
                </InfoRow>
            </InfoWrapper>
            </InfoContainer>
  );
};

export default InfoSection;